module.exports = __webpack_public_path__ + "img/scooter.09be7b25.svg";